import { NgModule } from '@angular/core';
import { SafeImageUrlPipe } from './safe-image-url.pipe';
import { SafeUrlPipe } from './safe-url.pipe';

@NgModule({
  declarations: [SafeUrlPipe, SafeImageUrlPipe],
  exports: [SafeUrlPipe, SafeImageUrlPipe],
  providers: [SafeUrlPipe, SafeImageUrlPipe],
})
export class SafeUrlModule {}
